import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { CompassColor, Link, Text } from "@noom/wax-component-library";

import { Partner } from "@/models";

const PARTNER_BRAND_DISCLAIMER_I18N_KEY = "landingFormPartnerBrandDisclaimer";

const highmarkPhoneNumberSupportLink = (
  <Link
    color={CompassColor.black}
    href="tel:866-459-4418"
    isExternal
    textDecoration="underline"
  />
);

const highmarkNetworkAccessPlanLink = (
  <Link
    color={CompassColor.black}
    href="https://www.highmarkbcbswv.com/networkaccessplan"
    isExternal
    textDecoration="underline"
  />
);

const highmarkNonDiscriminationPolicyLink = (
  // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
  <a
    href="https://www.highmark.com/non-discrimination"
    target="_blank"
    rel="noreferrer"
  />
);

type PartnerBrandDisclaimerProps = {
  partnerInfo: Partner | null;
};

export const PartnerBrandDisclaimer: React.FC<PartnerBrandDisclaimerProps> = ({
  partnerInfo,
}) => {
  const { t } = useTranslation();
  const partnerSlug = partnerInfo?.slug;

  const disclaimerText = partnerSlug
    ? t(PARTNER_BRAND_DISCLAIMER_I18N_KEY, {
        context: partnerSlug,
        defaultValue: "",
      })
    : "";
  if (!disclaimerText) {
    return null;
  }

  return (
    <Text size="sm">
      <Trans
        components={{
          highmarkNetworkAccessPlanLink,
          highmarkNonDiscriminationPolicyLink,
          highmarkPhoneNumberSupportLink,
        }}
        context={partnerSlug}
        i18nKey={PARTNER_BRAND_DISCLAIMER_I18N_KEY}
      />
    </Text>
  );
};
